import * as Yup from 'yup';

import { Nullable } from '~globals/types';
import { AdminBillingListBase } from '~services/admin/billingList/types';
import { VALIDATIONS_ERROR } from '~constants/validationsError';

export const FIELDS_NAME = {
  ENABLED: 'enabled',
  CODE: 'code',
  DESCRIPTION: 'description',
  MAX_DELIVERY_DAYS: 'maxDeliveryDays',
  VALUATION_TYPE_ID: 'valuationTypeId',
} as const;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getInitialValues = (data?: Nullable<AdminBillingListBase>) => ({
  [FIELDS_NAME.ENABLED]: data?.enabled ?? true,
  [FIELDS_NAME.CODE]: data?.billingListCode ?? '',
  [FIELDS_NAME.DESCRIPTION]: data?.description ?? '',
  [FIELDS_NAME.MAX_DELIVERY_DAYS]: String(data?.maxDeliveryBusinessDays ?? 7),
  [FIELDS_NAME.VALUATION_TYPE_ID]: String(data?.valuationTypeId ?? 0),
});

export const validationSchema = Yup.object().shape({
  [FIELDS_NAME.ENABLED]: Yup.boolean(),
  [FIELDS_NAME.CODE]: Yup.string().required(VALIDATIONS_ERROR.REQUIRED),
  [FIELDS_NAME.DESCRIPTION]: Yup.string().required(VALIDATIONS_ERROR.REQUIRED),
  [FIELDS_NAME.MAX_DELIVERY_DAYS]: Yup.string().required(
    VALIDATIONS_ERROR.REQUIRED,
  ),
  [FIELDS_NAME.VALUATION_TYPE_ID]: Yup.string().required(
    VALIDATIONS_ERROR.REQUIRED,
  ),
});
